export default __webpack_public_path__ + "static/media/venus-bg-effect-1.58ddc02a.svg";